/**
 * Copy for the impersonation block (ClickUp 86e39gctg), shared by the
 * sidebar, the collapsed rail and the phone-width bar.
 */

export const IMPERSONATION_REGION_LABEL = 'Impersonation'
export const IMPERSONATION_VIEWING_AS = 'Viewing as'
export const IMPERSONATION_EXIT = 'Exit'
export const IMPERSONATION_EXITING = 'Exiting…'
export const IMPERSONATION_EXIT_FAILED = 'Couldn’t exit impersonation. Try again.'

export const IMPERSONATION_ADMIN_BLOCKED =
  'Django admin is unavailable while impersonating. Exit impersonation first.'

/** Query param the backend adds when /admin is opened while impersonating. */
export const ADMIN_BLOCKED_PARAM = 'impersonation'
export const ADMIN_BLOCKED_VALUE = 'admin_blocked'

/**
 * "Viewing as Jane Doe · Grace Church · by Ada Admin" - the viewer is the
 * impersonator, so the last part says whose session this really is. Parts
 * the backend sent no name for are left off.
 *
 * @param {{target: {name: string}, tenant: {name: string}, impersonator: {name: string}}} impersonation
 * @returns {string}
 */
export function viewingAsText({ target, tenant, impersonator }) {
  return [
    `${IMPERSONATION_VIEWING_AS} ${target.name}`,
    tenant.name,
    impersonator?.name ? `by ${impersonator.name}` : '',
  ].filter(Boolean).join(' · ')
}

/**
 * Accessible name for the Exit control, which is an icon on the rail.
 *
 * @param {{target: {name: string}}} impersonation
 * @returns {string}
 */
export function exitLabel({ target }) {
  return `Exit impersonation of ${target.name}`
}
